import React, { useEffect, useRef } from "react";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import SunEditorCore from "suneditor/src/lib/core";

interface SunEditorReactProps {
  name: string;
  value?: string;
  placeholder?: string;
  onChange: (content: string) => void;
  minHeight?: string;
}

const SunEditorReact: React.FC<SunEditorReactProps> = ({
  name,
  value = "",
  placeholder = "Add your text here...",
  onChange,
  minHeight = "500px",
}) => {
  const editorRef = useRef<SunEditorCore | null>(null);
  const isInitialized = useRef(false);

  const getSunEditorInstance = (editor: SunEditorCore) => {
    editorRef.current = editor;
  };

  useEffect(() => {
    if (editorRef.current && !isInitialized.current) {
      editorRef.current.setContents(value);
      isInitialized.current = true;
    }
  }, [value]);

  return (
    <SunEditor
      name={name}
      placeholder={placeholder}
      onChange={onChange}
      getSunEditorInstance={getSunEditorInstance}
      setOptions={{
        minHeight,
        resizeEnable: false,
        defaultStyle: `
          direction: ltr;
          text-align: left;
          white-space: normal;
          line-height: 1.5;
        `,
        font: [
          "Arial",
          "Calibri",
          "Cambria",
          "Century Gothic",
          "Comic Sans MS",
          "Consolas",
          "Courier New",
          "Georgia",
          "Segoe UI",
          "Tahoma",
          "Times New Roman",
          "Verdana",
        ],
        buttonList: [[
          "undo", "redo",
          "font", "fontSize", "formatBlock",
          "bold", "underline", "italic",
          "fontColor", "hiliteColor",
          "removeFormat",
          "align", "list", "lineHeight",
          "link", "image",
          "codeView"
        ]]
      }}
    />
  );
};

export default SunEditorReact;
